// Info: Import React Dependancies
import React from 'react'

// Info: Import NPM Dependancies
import ReactDOM from 'react-dom/client'
import { Provider } from "react-redux"
import { createBrowserRouter, RouterProvider } from "react-router-dom"

// Info: Import Local Dependancies
import App from './App';
import store from './store/store'

export const router = createBrowserRouter([
  {
    path: ":lang/chat",
    element: <App />,
    children: [],
  }
])
/** Connect DOM & VDOM */
const root = ReactDOM.createRoot(
  document.getElementById('root')
)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
